<template>
  <div id="app">
    <Header />
    <Top />
    <Main />
    <About />
    <Purpose />
    <Trial />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Top from './components/Top.vue'
import Main from './components/Main.vue'
import About from './components/About.vue'
import Purpose from './components/Purpose.vue'
import Trial from './components/Trial.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Top,
    Main,
    About,
    Purpose,
    Trial,
    Footer
  }
}
</script>

<style>
#app {
  font-family: "Noto Sans Japanese", "din-2014", "Hiragino Kaku Gothic ProN", Meiryo, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 600;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
  padding: 0px;
}

ul {
  list-style: none;
  padding-inline-start: 0;
}

body {
  margin: 0px;
}

.hide-pc {
    display: none;
  }

@media screen and (max-width: 767px){
  .hide-sp {
    display:none;
  }

  .hide-pc {
    display: inline;
  }
  
}

</style>
